import { render } from "./QuebraCabeca2View.vue?vue&type=template&id=07b0749f&scoped=true"
import script from "./QuebraCabeca2View.vue?vue&type=script&lang=js"
export * from "./QuebraCabeca2View.vue?vue&type=script&lang=js"

import "./QuebraCabeca2View.vue?vue&type=style&index=0&id=07b0749f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07b0749f"]])

export default __exports__